import cn from 'classnames';
import { useAppDispatch } from '@brands/hooks/useReduxHook';
import { setStaffIntakeInProgress } from '@brands/store/slices/staffCaseCreationSlice';
import { useWindowSize } from '@brands/hooks';
import React, { useEffect } from 'react';

import Container from '../../../Components/Container/Container';
import Cases from './Sections/Cases/Cases';
import styles from './styles.module.scss';

const CollectorDashboard = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const screenSize = useWindowSize();

  useEffect(() => {
    dispatch(setStaffIntakeInProgress(false));
  }, [dispatch]);

  return (
    <Container
      patientDashboard
      childClassName={styles.dashboard}
      containerStyle={{
        justifyContent: screenSize.width >= 1289 ? 'center' : 'start',
        overflowY: screenSize.width >= 1289 ? 'hidden' : 'scroll',
      }}
      childrenStyle={{
        alignItems: 'flex-start',
        paddingTop: '2rem',
        width: '100%',
      }}
    >
      <div
        className={cn(styles.containerPf, styles.collectorDashboardBody)}
        style={{ display: 'flex', flexDirection: 'column' }}
      >
        <Cases />
      </div>
    </Container>
  );
};

export default CollectorDashboard;
